import ReactMarkdown from "react-markdown";

export const Markdown = ({ children }: { children: string }) => {
  return (
    <ReactMarkdown
      components={{
        p: ({ children, ...props }) => (
          <p className="nut-mt-1 nut-mb-2" {...props}>
            {children}
          </p>
        ),
        li: ({ children, ...props }) => (
          <li className="nut-mt-1 nut-mb-2" {...props}>
            {children}
          </li>
        ),
        ol: ({ children, ...props }) => (
          <ol className="nut-list-decimal nut-pl-6 nut-pb-2" {...props}>
            {children}
          </ol>
        ),
        ul: ({ children, ...props }) => (
          <ul className="nut-list-disc nut-pl-6" {...props}>
            {children}
          </ul>
        ),
        h1: ({ children, ...props }) => (
          <h1 className="nut-text-2xl nut-font-bold" {...props}>
            {children}
          </h1>
        ),
        h2: ({ children, ...props }) => (
          <h2 className="nut-text-xl nut-font-bold" {...props}>
            {children}
          </h2>
        ),
        h3: ({ children, ...props }) => (
          <h3 className="nut-text-lg nut-font-bold" {...props}>
            {children}
          </h3>
        ),
        h4: ({ children, ...props }) => (
          <h4 className="nut-text-md nut-font-bold" {...props}>
            {children}
          </h4>
        ),
      }}
    >
      {children}
    </ReactMarkdown>
  );
};
